<template>
    <div>
        <div class="card mb-3" id="regInfo-list">
            <div class="card-header headline cash-desk">
                <h4 class="text-white d-inline">لیست حسابهای متفرقه حسابداری</h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="input-group col-lg-5 mb-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text">سرفصل</span>
                        </div>
                        <vs-select :data="mainAccounts" :mode="'create'"
                                   :header="{multiple: false, label: 'title'}"
                                   @onChange="onChange"></vs-select>
                    </div>
                    <div class="input-group col-lg-5 mb-2">
                        <button class="btn btn-secondary float-left mx-2" @click="onCreateMainClicked">افزودن سرفصل</button>
                        <button class="btn btn-secondary float-left mx-2" @click="onCreateClicked">افزودن زیرسرفصل</button>
                    </div>
                    <div class="col-12 text-center" v-if="accountOutSource.length>0">
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class="text-center text-nowrap">سرفصل</th>
                                    <th class="text-center text-nowrap">زیرسرفصل</th>
                                    <!--<th class="text-center text-nowrap">نوع حساب</th>-->
                                    <th class="text-center text-nowrap">سال مالی</th>
                                    <th class="text-center text-nowrap">توضیحات</th>
                                </tr>
                                </thead>
                                <tbody v-if="accountOutSource !== undefined">
                                <tr v-for="(item,index) in accountOutSource">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td class="text-center clickable" @click="onCardClicked(index)">{{item.accountTitle}}</td>
                                    <td class="text-center clickable" @click="onCardClicked(index)">{{item.outSourceName}}</td>
                                    <!--<td class="text-center clickable" @click="onCardClicked(index)">{{item.accountNatures === 1 ?-->
                                        <!--"بدهکار"-->
                                        <!--: item.accountNatures === 2?-->
                                        <!--"بستانکار"-->
                                        <!--: "هردو"-->
                                        <!--}}-->
                                    <!--</td>-->
                                    <td class="text-center">{{item.saleMali}}</td>
                                    <td class="text-center">{{item.description}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 text-center" v-else>
                        <span>هیچ حسابی ثبت نشده است</span>
                    </div>
                </div>
            </div>
        </div>

        <!---------------------- MODALS ------------------------------>
        <div class="modal fade" id="mainAccount-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">ثبت سرفصل حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام سرفصل</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="mainModel.title">
                                </div>
                            </div>

                            <!--<div class="col-lg-6 my-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">سال مالی :</span>-->
                            <!--</div>-->
                            <!--<vs-select :data="saleMalis" :mode="'create'"-->
                            <!--:header="{multiple: false, label: 'name'}"-->
                            <!--@onChange="selectSalemali"></vs-select>-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع مانده حساب :</span>
                                    </div>
                                    <vs-select :data="accountNatures" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="selectaccountNatureMain"></vs-select>
                                </div>
                            </div>
                            <!--<div class="col-lg-12   my-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">توضیحات</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" type="text" v-model="accountOutSourceModel.description">-->
                            <!--</div>-->
                            <!--</div>-->

                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <!--<button type="button" class="btn btn-danger mr-2" @click="deleteMainItem()">حذف</button>-->
                        <button type="button" class="btn btn-primary" @click="onMainlOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="accountOutSource-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">ثبت حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">سرفصل حساب :</span>
                                    </div>
                                    <vs-select :data="mainAccounts" :mode="'create'"
                                               :header="{multiple: false, label: 'title'}"
                                               @onChange="selectMainAccount"></vs-select>
                                </div>
                            </div>

                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام زیر سرفصل</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="accountOutSourceModel.outSourceName">
                                </div>
                            </div>

                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">سال مالی :</span>
                                    </div>
                                    <vs-select :data="saleMalis" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="selectSalemali"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع مانده حساب :</span>
                                    </div>
                                    <vs-select :data="accountNatures" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="selectaccountNature"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-12   my-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">توضیحات</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="accountOutSourceModel.description">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger mr-2" @click="deleteItem()">حذف</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    import * as $ from 'jquery';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";
    import Moment from "moment-jalali";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';


    export default {
        name: 'accountOutSource',
        components: {VsSelect, DatePicker},
        data() {
            return {
                mainAccounts: [],
                regInfos: [],
                isMain: false,
                saleMalis: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 100
                },
                preselectedregInfo: {},
                preselectedAccountType: {},
                accountOutSource: [],
                accountOutSourceModel: {
                    outSourceName: "",
                    type: 0,
                    description: "",
                    saleMaliId: null,
                    rowVersion: "",
                    accountNature: 3,

                },
                mainModel: {
                    id: 0,
                    code: "",
                    title: "",
                    parrentId: null,
                    accountNature: 1,
                    accontType: 4,
                },
                accountNatures: [
                    {
                        accountNature: 1,
                        name: "بدهکار"
                    },
                    {
                        accountNature: 2,
                        name: "بستانکار"
                    },
                    {
                        accountNature: 3,
                        name: "هردو"
                    },

                ],
                selectedaccountNature: {},
                params: {
                    mode: 'create'
                },
                searchString: "",

                transactions: [],
                listView: true,
                transactionsQuery: {
                    pageSize: 8,
                    pageIndex: 0,
                    code: 0
                },
                dataCount: 0,
                transactionCount: 0,

                autoload: false,
                isSending: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",
                selectedMain: 0,

            }
        },
        mounted() {
            this.getAllMains();
            // this.getaccountOutSource();
            this.getsalemali();
            this.getOutsource();

        },
        methods: {
            getAllMains() {
                new BaseService('AccountTitle', '/GetAllHead').getList().then(response => {
                    let a = response.data;
                    this.mainAccounts = [];
                    let bb = {id: 0, title: "همه حسابها", code: 0};
                    this.mainAccounts.push(bb);
                    for (let i of a) {
                        switch (i.id) {
                            case 1:
                                i.title = "بانکها";
                                break;
                            case 2:
                                i.title = "صندوق ها";
                                break;
                            case 3:
                                i.title = "مشتری ها";
                                break;
                            case 4:
                                i.title = "اشخاص";
                                break;
                            case 5:
                                i.title = "تامین کننده ها";
                                break;
                            case 6:
                                i.title = "سرمایه(موجودی اولیه)";
                                break;
                            case 7:
                                i.title = "درآمدها";
                                break;
                            case 8:
                                i.title = "هزینه ها";
                                break;
                            case 10:
                                i.title = "فروش";
                                break;
                            case 11:
                                i.title = "خرید";
                                break;
                            case 12:
                                i.title = "چک های دریافتی";
                                break;
                            case 13:
                                i.title = "چک های پرداختی";
                                break;
                            case 14:
                                i.title = "";
                                break;
                            case 15:
                                i.title = "موجودی اولیه کالا";
                                break;
                            case 16:
                                i.title = "شرکاء";
                                break;
                            case 17:
                                i.title = "دارائی ها";
                                break;
                            case 18:
                                i.title = "بدهی ها";
                                break;
                            case 20:
                                i.title = "سرفصلهای حسابداری";
                                break;

                        }
                        this.mainAccounts.push(i);
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },


            getsalemali() {
                new BaseService('account', '/Getsalemali').getList().then(response => {
                    if (response.data !== null && response.data !== "") {
                        this.saleMalis = response.data.value;
                    }
                    if (this.saleMalis.length > 0) {
                        for (let item of this.saleMalis) {
                            item.fstartDate = Moment(item.startDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                            item.fendDate = Moment(item.endDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onCreateMainClicked() {
                $("#mainAccount-modal").modal("show");
            },
            onChange: function (val) {
                if (val) {
                    if (val.id === 0) {
                        this.selectedMain = val.code;
                        this.queryParams.outsourceType = this.selectedMain;
                        this.queryParams.pageIndex = 0;
                        this.queryParams.types = 100;
                        this.getOutsource();
                        // this.addtypes();
                        // this.queryParams2.types = this.selectedMain;
                    } else {
                        this.selectedMain = val.code;
                        this.queryParams.outsourceType = this.selectedMain;
                        this.queryParams.pageIndex = 0;
                        // this.queryParams2.types = this.selectedMain;
                        this.queryParams.types = this.selectedMain;
                        this.getOutsource();
                    }
                }

            },
            getOutsource() {
                this.accountOutSource = [];
                this.dataCount = 0;
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.accountOutSource = response.data.data;
                    this.dataCount = response.data.count;
                    if (this.accountOutSource.length > 0) {
                        for (let i of this.accountOutSource) {
                            if (i.saleMaliId !== null) {
                                for (let s of this.saleMalis) {
                                    if (s.id == i.saleMaliId) {
                                        i.saleMali = s.name;
                                    }
                                }

                            }
                            for (let a of this.mainAccounts) {
                                if (i.type == a.code) {
                                    i.accountTitle = a.title;
                                }
                            }

                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },

            onCreateClicked() {
                this.accountOutSourceModel.id = undefined;
                $("#accountOutSource-modal").modal("show");
            },
            onCardClicked(index) {
                this.accountOutSourceModel = JSON.parse(JSON.stringify(this.accountOutSource[index]));
                $("#accountOutSource-modal").modal("show");
            },
            onMainlOk() {
                if (this.mainModel.name === null || this.mainModel.name === "") {
                    Utils.handleErrorWithNotification("لطفا نام سرفصل حساب را کنید", this.$noty);
                } else {
                    if (!this.isSending) {
                        this.isSending = true;
                        new BaseService('AccountTitle/CreateMain').create(this.mainModel).then(response => {
                            this.$noty.success("اطلاعات با موفقیت ثبت شد.");
                            this.isSending = false;
                            this.getAllMains();
                            $("#mainAccount-modal").modal("hide");
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }

                }
            },
            onModalOk() {
                if (this.accountOutSourceModel.outSourceName === null || this.accountOutSourceModel.outSourceName === "") {
                    Utils.handleErrorWithNotification("لطفا نام حساب را وارد کنید", this.$noty);
                } else if (this.accountOutSourceModel.type === null || this.accountOutSourceModel.type === "" || this.accountOutSourceModel.type === 0) {
                    Utils.handleErrorWithNotification("لطفا سرفصل حساب را انتخاب کنید", this.$noty);
                } else {
                    if (!this.isSending) {
                        this.isSending = true;
                        this.accountOutSourceModel.rowVersion = this.generateUuid();
                        new BaseService('OutSource').create(this.accountOutSourceModel).then(response => {
                            this.$noty.success("اطلاعات با موفقیت ثبت شد.");
                            this.isSending = false;
                            this.getOutsource();
                            $("#accountOutSource-modal").modal("hide");
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }

                }
            },
            selectMainAccount(val) {
                if (val) {
                    this.accountOutSourceModel.type = val.code;
                }
            },
            selectSalemali(val) {
                if (val) {
                    this.accountOutSourceModel.saleMaliId = val.id;
                } else {
                    this.accountOutSourceModel.saleMaliId = null;
                }
            },
            selectaccountNatureMain(val) {
                if (val && val.accountNature) {

                    this.mainModel.accountNature = val.accountNature;
                }
            },
            selectaccountNature(val) {
                if (val && val.accountNature) {

                    this.accountOutSourceModel.accountNature = val.accountNature;
                } else {
                    this.accountOutSourceModel.accountNature = 3;
                }
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.accountOutSourceModel.startDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.accountOutSourceModel.endDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            deleteItem() {
                if (confirm("آیا میخواهید این حساب را حذف کنید؟")) {
                    if (!this.isSending) {
                        this.isSending = true;
                        new BaseService('OutSource').delete(this.accountOutSourceModel.id).then(response => {
                            this.$noty.success("اطلاعات با موفقیت حذف شد.");
                            this.isSending = false;
                            this.getaccountOutSource();
                            $("#accountOutSource-modal").modal("hide");
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }
                }
            },

        },

    }
</script>